import React from 'react'

function DoctorPatientView() {
  return (
    <div className="container-fluid">
    <div style={{ borderBottom: "1px dashed gray", paddingBottom: "1rem" }} className="col-12 mb-4 d-flex justify-content-between">

        <div className="d-flex">
            <h4 className='m-0 p-3'>
                Patient Profile
            </h4>

        </div>

        <div className='d-flex align-items-center justify-content-end gap-3'>
            <div className='d-flex align-items-center gap-3'>
                <div className="position-relative div-okij8ijj">
                    <input type="text" className="form-control div-TzEiOdMeYO" placeholder='Search here' style={{ padding: "0px 1.7rem 0px .5rem", borderRadius: ".3rem" }} />
                    <div className="position-absolute" style={{ top: "10px", right: '8px' }}>
                        <button style={{ background: "none", border: 'none', }}><i class="fa-solid fa-magnifying-glass"></i></button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div className="container-fluid">
        <div className="row mb-3">

            <div className="col-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4 mb-3">
                <div className="div-boxbodyshadowRecord rounded-3 bg-white p-3 shadow-sm">

                    <div className="d-flex gap-3 border-bottom pb-3">
                        <img className='img-fluid' style={{ width: "10rem" }} src="/Images/avatar-24.png" alt="" srcset="" />

                        <div className="d-flex flex-column">

                            <div className="d-flex align-items-center gap-2 flex-wrap justify-content-between mb-2">
                                <span className='fw-bold'>
                                    Rohan
                                </span>

                                <span style={{ fontSize: "0.7rem", background: "#EDFDF1", padding: "0.4rem", borderRadius: "1rem" }}>
                                    #123456abc
                                </span>
                            </div>

                            <span style={{ fontSize: "0.6rem", color: "lightgrey" }}>
                                Join In date 21 August 2020, 12:45 AM
                            </span>

                            <div className="d-flex mt-2 mb-2 gap-3 flex-wrap align-items-center">
                                <span style={{ fontSize: "0.7rem", background: "#EDFDF1", padding: "0.4rem", borderRadius: "1rem" }}>Age : 68</span>
                                <span style={{ fontSize: "0.7rem", background: "#FDEDED", padding: "0.4rem", borderRadius: "1rem" }}>Blood Group : O+</span>
                                <span style={{ fontSize: "0.7rem", background: "#F5F5F5", padding: "0.4rem", borderRadius: "1rem" }}>Status : <span className='fw-bold text-success'>ACTIVE</span></span>
                            </div>

                        </div>
                    </div>

                    <div className="d-flex justify-content-between flex-wrap align-items-center gap-2 pt-2">
                        <div className="d-flex align-items-center gap-2">
                            <i class="fa-solid fa-phone fa-sm" style={{ color: "#2BC155" }}></i>
                            <span style={{ fontSize: "0.7rem" }}>+91 1234567890</span>
                        </div>

                        <div className="d-flex align-items-center gap-2">
                            <i class="fa-solid fa-location-dot fa-sm" style={{ color: "#F46B68" }}></i>
                            <span style={{ fontSize: "0.7rem" }}>Vizag , Andhra Pradesh</span>
                        </div>
                    </div>

                </div>
            </div>

            <div className="col-12 col-md-6 col-lg-6 col-xl-8 col-xxl-8 mb-3">
                <div className="div-boxbodyshadowRecord rounded-3 bg-white p-3 shadow-sm">
                    <span>
                        Medical History
                    </span>

                    <hr style={{ borderTop: "grey 1px dashed" }} />

                    <div className="d-flex flex-column align-items-center justify-content-between my-2" style={{ height: "8rem", overflowX: "scroll" }}>

                        <span className=''>
                            The patient was advised to continue monitoring blood pressure and blood sugar levels at home.
                            They were encouraged to maintain regular physical activity and adhere to prescribed medications.
                            A follow-up appointment is scheduled for <strong>June 2024</strong>.
                        </span>

                        <hr style={{ borderTop: "grey 1px solid" }} />

                        <span className=''>
                            The patient was advised to continue monitoring blood pressure and blood sugar levels at home.
                            They were encouraged to maintain regular physical activity and adhere to prescribed medications.
                            A follow-up appointment is scheduled for <strong>May 2024</strong>.
                        </span>

                        <hr style={{ borderTop: "grey 1px solid" }} />

                        <span className=''>
                            The patient was advised to continue monitoring blood pressure and blood sugar levels at home.
                            They were encouraged to maintain regular physical activity and adhere to prescribed medications.
                            A follow-up appointment is scheduled for <strong>April 2024</strong>.
                        </span>

                    </div>

                </div>

            </div>

            <div className="row mt-4">

                <div className="col-12 col-md-12 col-xl-6 mb-3">
                    <div className="div-boxbodyshadowRecord rounded-3 bg-white p-3 shadow-sm">
                        <div className="d-flex justify-content-between">
                            <span>
                                Treatment History
                            </span>

                            <div className="d-flex align-items-center gap-2 text-primary">
                             <a href="" style={{textDecoration:"none"}}>   <span>
                                    view all
                                </span></a>
                                <i class="fa-solid fa-chevron-right"></i>
                            </div>
                        </div>

                        <hr style={{ borderTop: "grey 1px dashed" }} />



                        <div className="d-flex flex-column" style={{ height: "15rem", overflowX: "scroll" }}>
                            <div className="">
                                <span style={{ backgroundColor: "#F6F6F6", borderRadius: "5px" }} className="d-flex p-2 align-items-center justify-content-between my-1">
                                    <div className="d-flex align-items-center gap-3">
                                        <img src="/Images/Group9.png" alt="" />
                                        <span className="d-flex flex-column align-items-start">
                                            <span className="m-1">Diabetes</span>
                                            <span style={{ color: "gray", fontSize: "12px" }} className="m-1">Sat, 23 Jul 2020, 01:24 PM</span>
                                        </span>
                                    </div>

                                    <span className="d-flex flex-column align-items-start">
                                        <span className="m-1" style={{ fontSize: "0.8rem" }}>Assigned to  <span style={{ color: "#2662F0" }} className="mx-1">DR. Sampath</span></span>
                                        <span className="m-1" style={{ fontSize: "0.8rem" }}>Visit Type  <span style={{ color: "#2BC155" }} className="mx-1">In-person</span></span>
                                    </span>
                                </span>
                            </div>

                            <div className="">
                                <span style={{ backgroundColor: "#F6F6F6", borderRadius: "5px" }} className="d-flex p-2 align-items-center justify-content-between my-1">
                                    <div className="d-flex align-items-center gap-3">
                                        <img src="/Images/Group9.png" alt="" />
                                        <span className="d-flex flex-column align-items-start">
                                            <span className="m-1">Diabetes</span>
                                            <span style={{ color: "gray", fontSize: "12px" }} className="m-1">Sat, 23 Jul 2020, 01:24 PM</span>
                                        </span>
                                    </div>

                                    <span className="d-flex flex-column align-items-start">
                                        <span className="m-1" style={{ fontSize: "0.8rem" }}>Assigned to  <span style={{ color: "#2662F0" }} className="mx-1">DR. Kiran</span></span>
                                        <span className="m-1" style={{ fontSize: "0.8rem" }}>Visit Type  <span style={{ color: "#2BC155" }} className="mx-1">In-person</span></span>
                                    </span>
                                </span>
                            </div>

                            <div className="">
                                <span style={{ backgroundColor: "#F6F6F6", borderRadius: "5px" }} className="d-flex p-2 align-items-center justify-content-between my-1">
                                    <div className="d-flex align-items-center gap-3">
                                        <img src="/Images/Group9.png" alt="" />
                                        <span className="d-flex flex-column align-items-start">
                                            <span className="m-1">Diabetes</span>
                                            <span style={{ color: "gray", fontSize: "12px" }} className="m-1">Sat, 23 Jul 2020, 01:24 PM</span>
                                        </span>
                                    </div>

                                    <span className="d-flex flex-column align-items-start">
                                        <span className="m-1" style={{ fontSize: "0.8rem" }}>Assigned to  <span style={{ color: "#2662F0" }} className="mx-1">DR. Hemanth</span></span>
                                        <span className="m-1" style={{ fontSize: "0.8rem" }}>Visit Type  <span style={{ color: "#2BC155" }} className="mx-1">In-person</span></span>
                                    </span>
                                </span>
                            </div>

                            <div className="">
                                <span style={{ backgroundColor: "#F6F6F6", borderRadius: "5px" }} className="d-flex p-2 align-items-center justify-content-between my-1">
                                    <div className="d-flex align-items-center gap-3">
                                        <img src="/Images/Group9.png" alt="" />
                                        <span className="d-flex flex-column align-items-start">
                                            <span className="m-1">Diabetes</span>
                                            <span style={{ color: "gray", fontSize: "12px" }} className="m-1">Sat, 23 Jul 2020, 01:24 PM</span>
                                        </span>
                                    </div>

                                    <span className="d-flex flex-column align-items-start">
                                        <span className="m-1" style={{ fontSize: "0.8rem" }}>Assigned to  <span style={{ color: "#2662F0" }} className="mx-1">DR. Rao</span></span>
                                        <span className="m-1" style={{ fontSize: "0.8rem" }}>Visit Type  <span style={{ color: "#2BC155" }} className="mx-1">In-person</span></span>
                                    </span>
                                </span>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="col-12 col-md-12 col-xl-6 mb-3">
                    <div className="div-boxbodyshadowRecord rounded-3 bg-white p-3 shadow-sm">
                        <div className="d-flex justify-content-between">
                            <span>
                                Test and Lab Reports History
                            </span>

                            <div className="d-flex align-items-center gap-2 text-primary">
                            <a href="" style={{textDecoration:"none"}}>   <span>
                                    view all
                                </span></a>
                                <i class="fa-solid fa-chevron-right"></i>
                            </div>
                        </div>

                        <hr style={{ borderTop: "grey 1px dashed" }} />

                        <div className="d-flex flex-column" style={{ height: "15rem", overflowX: "scroll" }}>
                            <div className="">
                                <span style={{ backgroundColor: "#F6F6F6", borderRadius: "5px" }} className="d-flex p-2 align-items-center justify-content-between my-1">
                                    <div className="d-flex align-items-center gap-3">
                                        <span className='rounded-circle bg-danger' style={{ height: "2rem", width: "2rem" }}>
                                        </span>
                                        <span className="d-flex flex-column align-items-start">
                                            <span className="m-1">Blood Test Results</span>
                                            <span style={{ color: "gray", fontSize: "12px" }} className="m-1">Sat, 23 Jul 2020, 01:24 PM</span>
                                        </span>
                                    </div>

                                    <span className="d-flex flex-column align-items-start">
                                        <span className="m-1" style={{ fontSize: "0.8rem" }}>Assigned to  <span style={{ color: "#2662F0" }} className="mx-1">DR. Riya</span></span>
                                        <span style={{ color: "#2BC155" }} className="mx-1">View Report</span>
                                    </span>
                                </span>
                            </div>

                            <div className="">
                                <span style={{ backgroundColor: "#F6F6F6", borderRadius: "5px" }} className="d-flex p-2 align-items-center justify-content-between my-1">
                                    <div className="d-flex align-items-center gap-3">
                                        <span className='rounded-circle bg-primary' style={{ height: "2rem", width: "2rem" }}>
                                        </span>
                                        <span className="d-flex flex-column align-items-start">
                                            <span className="m-1">X-ray</span>
                                            <span style={{ color: "gray", fontSize: "12px" }} className="m-1">Sat, 23 Jul 2020, 01:24 PM</span>
                                        </span>
                                    </div>

                                    <span className="d-flex flex-column align-items-start">
                                        <span className="m-1" style={{ fontSize: "0.8rem" }}>Assigned to  <span style={{ color: "#2662F0" }} className="mx-1">DR. Sanjay</span></span>
                                        <span style={{ color: "#2BC155" }} className="mx-1">View Report</span>
                                    </span>
                                </span>
                            </div>


                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>




</div>
  )
}

export default DoctorPatientView